module.exports = __webpack_public_path__ + "e269780c0b099a7b3f8da4c971f7dd9f.png";